import { type Common } from '../common.js';
import { type FindAllOptions, type VoicePersona } from '../models/assistant/voicePersona.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/voice-personas';
  }

  async findAll(options: FindAllOptions): Promise<VoicePersona[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<VoicePersona> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }
}
